export enum OwnGrowthGridCategory {
  Overview = 'Overview',
  Customer = 'Customer',
  Speed = 'Speed',
  Teamwork = 'Teamwork',
  Excellence = 'Excellence',
  Innovation = 'Innovation',
  HumanValues = 'HumanValues',
}
